export default __webpack_public_path__ + "static/media/ISKO CLASS-10 EXAM PATTERN 2026-27.b50acaa6.pdf";